'use client'

import Breadcrumb, { BreadcrumbProps } from 'antd/lib/breadcrumb'
import Link from 'next/link'
import { styled } from 'styled-components'

interface BreadCrumbsProps {
  crumbs: { label: string; href: string; disabled?: boolean }[]
  breadcrumbProps?: BreadcrumbProps
}

/**
 *
 * @deprecated use v2 instead
 */
export const BreadCrumbs = ({ crumbs, breadcrumbProps }: BreadCrumbsProps) => {
  return (
    <StyledBreadCrumbWrapper {...breadcrumbProps} separator=">">
      {crumbs.map((crumb) => {
        return (
          <StyledBreadCrumb key={crumb.label}>
            {crumb.disabled ? (
              crumb.label
            ) : (
              <Link href={crumb.href}>{crumb.label}</Link>
            )}
          </StyledBreadCrumb>
        )
      })}
    </StyledBreadCrumbWrapper>
  )
}

const StyledBreadCrumbWrapper = styled(Breadcrumb)`
  ${({ theme: { base } }: any) => `
  .ant-breadcrumb-separator {
    color: #B3B3B3;
    margin: 0 12px;
  }
  `}
`

const StyledBreadCrumb = styled(Breadcrumb.Item)`
  ${({ theme: { base } }: any) => `
    color: #000000;
    `}

  a {
    color: inherit;
    text-transform: capitalize;
  }
  text-transform: capitalize;
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
`
